import { gql } from '@apollo/client';
import React from 'react';
import { Breakpoint } from '@moda/om';
import {
  DesktopProductMediaGallery,
  DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT,
  Props
} from './DesktopProductMediaGallery';
import {
  MobileProductMediaGallery,
  MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT
} from './MobileProductMediaGallery';

export const PRODUCT_MEDIA_GALLERY_FRAGMENT = gql`
  fragment ProductMediaGalleryFragment on Variant {
    ...DesktopProductMediaGalleryFragment
    ...MobileProductMediaGalleryFragment
  }
  ${DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT}
  ${MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT}
`;

export const ProductMediaGallery: React.FC<Props> = props => {
  return (
    <>
      <Breakpoint gt="sm">
        <DesktopProductMediaGallery {...props} />
      </Breakpoint>

      <Breakpoint lt="sm">
        <MobileProductMediaGallery {...props} />
      </Breakpoint>
    </>
  );
};
